import React, { useEffect, useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";

import axios from "axios";

import { updateOrder } from "./slice/posSlice";
import { setCommonState, setPrintrtTyp } from "commonSlice/commonSlice";
import filterStatusValue from "utils/filterStatusValue";
import CommonBackdrop from "loader/CommonBackdrop";

import { baseUrl, redirectUrl } from "config";

import { useSnackBar } from "context/snackbarContext";
import { Box, Typography } from "@mui/material";

const PRINTER_AND_OTHER_URL = "/getPrinterNameAndOther";
const STATUS_TABLE_DATA_URL = "/main/getStatusDataByTyp";

const OrderLayout = () => {
  const { showSnackbar } = useSnackBar();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleApiError = useCallback((err) => {
    if (err.response) {
      if (err.response.status === 403 || err.response.status === 401) {
        redirectUrl();
      } else {
        showSnackbar(
          "error",
          `API Error: ${err.response.status} - ${
            err.response.data?.message || "Something went wrong."
          }`
        );
      }
    } else if (err.request) {
      showSnackbar("error", "Network Error: No response received from server.");
    } else {
      showSnackbar("error", "An unexpected error occurred.");
    }
    setError(err);
  }, []);

  useEffect(() => {
    const fetchInitialData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const [printerRes, isRestaurantRes] = await Promise.all([
          axios.get(baseUrl + PRINTER_AND_OTHER_URL, { withCredentials: true }),
          axios.post(
            baseUrl + STATUS_TABLE_DATA_URL,
            { param: "IS_RESTAURANT" },
            { withCredentials: true }
          ),
        ]);

        const commonParams = printerRes.data[1];
        const taxUtilities = printerRes.data[2];

        const decimal = filterStatusValue(
          commonParams,
          "params",
          "DECIMAL_VALUE"
        )[0].VALUE;

        dispatch(setPrintrtTyp(printerRes.data));
        dispatch(
          setCommonState({
            isADDon:
              filterStatusValue(commonParams, "params", "ADD_ON")[0]?.VALUE ===
              "YES",
            decimalCount: Number(decimal),
            allKot:
              filterStatusValue(commonParams, "params", "ALL_KOT")[0]?.VALUE ===
              "YES",
            isInvoice:
              filterStatusValue(commonParams, "params", "IS_INVOICE")[0]
                ?.VALUE === "YES",
            taxUtilitiesListData: taxUtilities,
            KotEnabled:
              filterStatusValue(commonParams, "params", "KOT_ENABLED")[0]
                ?.VALUE === "YES",
            IsRestaurant:
              filterStatusValue(commonParams, "params", "IS_RESTAURANT")[0]
                ?.VALUE === "YES",
            salesBillDeclaration: filterStatusValue(
              commonParams,
              "params",
              "SALESBILL_DECLARATION"
            )[0]?.VALUE,
            orderFormDeclaration: filterStatusValue(
              commonParams,
              "params",
              "ORDERFORM_DECLARATION"
            )[0]?.VALUE,
            billWiseTax: filterStatusValue(
              commonParams,
              "params",
              "bill_Wise_Tax%"
            )[0]?.VALUE,
            isPaidMethod: filterStatusValue(
              commonParams,
              "params",
              "PAID_METHOD_WINDOW"
            )[0]?.VALUE,
            isDiscount: filterStatusValue(
              commonParams,
              "params",
              "IS_DISCOUNT"
            )[0]?.VALUE,
          })
        );

        if (
          isRestaurantRes.data.success &&
          isRestaurantRes?.data?.data?.[0]?.value
        ) {
          dispatch(
            updateOrder({
              isRestaurant: isRestaurantRes.data.data[0].value === "YES",
              tax: filterStatusValue(
                commonParams,
                "params",
                "bill_Wise_Tax%"
              )[0]?.VALUE,
            })
          );
        } else {
          showSnackbar(
            "warning",
            "Could not get IS_RESTAURANT status table data correctly."
          );
        }
      } catch (err) {
        handleApiError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  if (error && !isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography color="error" variant="h6">
          Failed to load initial data. Please try again later.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <CommonBackdrop open={false} />
      <Outlet />
    </>
  );
};

export default OrderLayout;
